import {
  // 单选、多选组合国家筛选器
  COMPOSED_COUNTRY_SELECT as COMPOSED_COUNTRY_SELECT_FILTER,
  // 单选榜单筛选器
  SINGLE_SOURCE_SELECT as SINGLE_SOURCE_SELECT_FILTER,
  // 多选榜单筛选器
  MULTIPLE_SOURCE_SELECT as MULTIPLE_SOURCE_SELECT_FILTER,
  // 是否显示热度国家筛选器
  HEAT_MAP as SHOW_HEAT_MAP_SELECT_FILTER,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';

export const getInitialFilterParams = (isOperate: boolean, filterExtend: any, defaultFilterParams: any): any => {
  if (!isOperate) return defaultFilterParams;

  const composedCountryFilterExtend = filterExtend?.[COMPOSED_COUNTRY_SELECT_FILTER]?.value;
  const singleSourceFilterExtend = filterExtend?.[SINGLE_SOURCE_SELECT_FILTER];
  const multipleSourceFilterExtend = filterExtend?.[MULTIPLE_SOURCE_SELECT_FILTER];
  const showHeatMapFilterExtend = filterExtend?.[SHOW_HEAT_MAP_SELECT_FILTER];

  const initialSelectedType = composedCountryFilterExtend?.type || defaultFilterParams?.selectedType;
  const initialRegionValue = composedCountryFilterExtend?.countries?.length
    ? composedCountryFilterExtend?.countries
    : initialSelectedType === 'multiple' ? ['global'] :defaultFilterParams?.regionValue;
  const initialSingleDataSource = singleSourceFilterExtend?.value
    ? [singleSourceFilterExtend?.value]
    : defaultFilterParams?.dataSourceSim;
  const initialMultipleDataSource = multipleSourceFilterExtend?.value?.length
    ? multipleSourceFilterExtend?.value
    : defaultFilterParams?.dataSourceMul;
  const initialDataSource = initialSelectedType === 'single' ? initialMultipleDataSource : initialSingleDataSource;
  const initialShowHeatMap = showHeatMapFilterExtend?.value || defaultFilterParams?.showHeatMap;

  return {
    selectedType: initialSelectedType,
    regionType: 'markets',
    regionValue: initialRegionValue,
    dataSourceSim: initialSingleDataSource,
    dataSourceMul: initialMultipleDataSource,
    dataSource: initialDataSource,
    showHeatMap: initialShowHeatMap,
  };
};
